/*
 * Dot indicators for scroll-snap carousels.
 *
 * The scrolling itself is CSS (overflow-x + scroll-snap), so the row works
 * with JS disabled and keeps native momentum and accessibility. This only
 * adds the dots, and only while the layout is actually a carousel — above the
 * breakpoint the same markup is a grid, where dots would be meaningless.
 */
(function () {
  'use strict';

  var CAROUSEL = window.matchMedia('(max-width: 749px)');

  function setup(list) {
    var dots = document.querySelector(
      '[data-owala-carousel-dots]'
    );
    var wrapper = list.parentElement;
    if (wrapper) dots = wrapper.querySelector('[data-owala-carousel-dots]');
    if (!dots) return;

    var items = Array.prototype.slice.call(list.children);
    var buttons = [];

    function build() {
      dots.textContent = '';
      buttons = items.map(function (item, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'owala-dot';
        b.setAttribute('aria-label', 'Go to item ' + (i + 1) + ' of ' + items.length);
        b.addEventListener('click', function () {
          // Rect maths rather than offsetLeft: the items' offsetParent is not
          // the list, so offsetLeft is measured from an unrelated ancestor.
          var delta = item.getBoundingClientRect().left - list.getBoundingClientRect().left;
          // Setting the position directly rather than scrollTo with
          // behavior:'smooth' — that call silently does nothing in some
          // engines, leaving the dot inert. CSS scroll-behavior supplies the
          // animation where it is supported, and honours reduced motion.
          list.scrollLeft = list.scrollLeft + delta;
          sync();
        });
        dots.appendChild(b);
        return b;
      });
    }

    function sync() {
      // Nearest item to the current scroll position wins, which stays correct
      // mid-drag rather than only after a snap settles.
      var best = 0;
      var bestGap = Infinity;
      var listLeft = list.getBoundingClientRect().left;
      items.forEach(function (item, i) {
        var gap = Math.abs(item.getBoundingClientRect().left - listLeft);
        if (gap < bestGap) {
          bestGap = gap;
          best = i;
        }
      });
      buttons.forEach(function (b, i) {
        b.classList.toggle('is-active', i === best);
        b.setAttribute('aria-current', i === best ? 'true' : 'false');
      });
    }

    function enable() {
      build();
      dots.hidden = false;
      sync();
    }

    function disable() {
      dots.hidden = true;
      dots.textContent = '';
      buttons = [];
    }

    function apply() {
      if (CAROUSEL.matches) enable();
      else disable();
    }

    // Called directly rather than through requestAnimationFrame: with a
    // handful of items the work is trivial, and an rAF guard leaves the
    // throttle latched on if a frame never arrives, which silently freezes
    // the dots.
    list.addEventListener(
      'scroll',
      function () {
        if (CAROUSEL.matches) sync();
      },
      { passive: true }
    );

    if (CAROUSEL.addEventListener) CAROUSEL.addEventListener('change', apply);
    else CAROUSEL.addListener(apply);

    apply();
  }

  document.querySelectorAll('[data-owala-carousel]').forEach(setup);
})();
